'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { Fragment } from 'react';
import { arrayFrom } from '@s7/utils';

// TODO: Переписать на основе собственного шаблонизатора.
var linkRegex = /@link{(.+?),(.+?)}/g;
/** Заменяет вхождение @link{text,href} на компонент ссылки */ var compileJsxLinkTemplate = function(template, Component) {
    var matches = arrayFrom(template.matchAll(linkRegex));
    if (!matches.length) {
        return template;
    }
    var result = [];
    var tail = template;
    matches.forEach(function(param, index) {
        var excerpt = param[0], children = param[1], href = param[2];
        var excerptIndex = tail.indexOf(excerpt);
        var lhs = tail.substring(0, excerptIndex);
        var rhs = tail.substring(excerptIndex + excerpt.length);
        result.push(/*#__PURE__*/ jsx(Fragment, {
            children: lhs
        }, "l-" + index), /*#__PURE__*/ jsx(Component, {
            href: href,
            children: children
        }, index));
        tail = rhs;
        if (index === matches.length - 1 && rhs) {
            result.push(/*#__PURE__*/ jsx(Fragment, {
                children: rhs
            }, "r-" + index));
        }
    });
    return result;
};

export { compileJsxLinkTemplate };
